module.exports = __webpack_public_path__ + "img/AfricaCDC_COVID-19_fb.db382431.jpg";